import React from 'react';
// Removendo a importação dos ícones problemáticos
// import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-dark text-white">
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo e Informações */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-serif font-bold text-primary mb-6">Raquel de Araujo</h3>
            <p className="text-white/70 mb-6">
              Design & Life - Transformando espaços e negócios com design estratégico e soluções personalizadas.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/raqueldearaujo.r/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors">
                <span className="text-sm">IG</span>
              </a>
              <a href="https://www.linkedin.com/in/raquel-de-ara%C3%BAjo-00409923/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors">
                <span className="text-sm">IN</span>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-bold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="text-white/70 hover:text-primary transition-colors">Home</a></li>
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors">Serviços</a></li>
              <li><a href="#about" className="text-white/70 hover:text-primary transition-colors">Sobre</a></li>
              <li><a href="#portfolio" className="text-white/70 hover:text-primary transition-colors">Portfólio</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-primary transition-colors">Contato</a></li>
            </ul>
          </div>

          {/* Serviços */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-bold mb-6">Serviços</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors">Design de Interiores</a></li>
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors">Visual Merchandising</a></li>
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors">Gestão Ambiental</a></li>
              <li><a href="#services" className="text-white/70 hover:text-primary transition-colors">Marketing Estratégico</a></li>
            </ul>
          </div>

          {/* Contato */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-bold mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="text-primary mt-1 mr-3">📍</span>
                <span className="text-white/70">Curitiba - PR, Brasil</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-3">📞</span>
                <span className="text-white/70">+55 41 99911-9143</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-3">✉️</span>
                <span className="text-white/70">contato@raqueldesign.com.br</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Parcerias */}
      <div className="border-t border-white/10 py-8">
        <div className="container">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-white/50 text-sm mb-4 md:mb-0">
              Parcerias: SEBRAE-PR, UNINTER
            </div>
            <div className="text-white/50 text-sm">
              &copy; {currentYear} Raquel de Araujo Design & Life. Todos os direitos reservados.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 